import React from 'react'
import {SuspenseWhileLoading} from '@oc/components'

const Decommissioning = React.lazy(async () => ({
    default: (await import('@oc/decommissioning/module')).DecommissioningModule
}))

export function DecommissioningComponent() {
    return <SuspenseWhileLoading LazyComponent={Decommissioning} />
}
